module.exports = __webpack_public_path__ + "img/five-nights-at-freddys.f1348969.png";